"use client";

export {
  RecordingDataAdapterProvider,
  useRecordingDataAdapter,
  useRecordingDataAdapterOptional,
  useRecordingDemoMetadata,
} from "./recording-data-adapter-provider";
